export const INITIAL_ONBOARDING_EVENT_NAME = 'initial_teacher_onboarding_completed';
export const REPEAT_ONBOARDING_EVENT_NAME = 'repeat_teacher_onboarding_completed';

/**
 * This is in essence a duplicate of `RecommendedArticlesContentRule` until
 * we introduce multi-subject support. Until then, there's no reason to
 * use rules API.
 */
export const SUBJECT_HEADER_MAPPING = {
  'English/Language Arts/Reading': [8676, 11160],
  'English Language Learners': [7351, 8541],
  'Foreign Language': [8048, 11040],
  'General Elementary': [7835, 11268],
  Math: [10358, 10986],
  Science: [7579, 9827, 10363],
  'Social Studies/Social Science': [10970, 11257, 11195],
  'Special Education': [11099],
};

export const SUBJECT_TO_SLUG_MAPPING = {
  'English/Language Arts/Reading': 'english-arts-reading',
  'English Language Learners': 'english-language-learner',
  'Foreign Language': 'foreign-language',
  'General Elementary': 'general-elementary',
  Math: 'math',
  Science: 'science',
  'Social Studies/Social Science': 'social-studies',
  'Special Education': 'special-education',
  Other: 'other',
};
